// extracted by mini-css-extract-plugin
export var link = "contact-module--link--2pUin";
export var image = "contact-module--image--dM7Kz";
export var linkText = "contact-module--linkText--6jXBE";